import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Intercepter les erreurs DOM liées au cleanup de html5-qrcode pour les ignorer
window.addEventListener('error', (event) => {
  const error = event.error || {};
  const errorMsg = String(error.message || event.message || '');
  const errorName = error.name || '';
  
  if (
    errorMsg.includes('removeChild') ||
    errorMsg.includes('not a child') ||
    errorName === 'NotFoundError'
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason || {};
  const errorMsg = String(error.message || '');
  const errorName = error.name || '';
  
  if (
    errorMsg.includes('removeChild') ||
    errorMsg.includes('not a child') ||
    errorName === 'NotFoundError'
  ) {
    event.preventDefault();
    return false;
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)








